import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { MessagesList } from '@layout/AdminPage';
import { Icon, InvisibleButton } from '@atoms';
import { Panel } from '@layout';
import { IntroMessageCreateForm } from './IntroMessageCreateForm';

const clientLabelStyle = {
  padding: '10px',
  marginRight: '10px',
  boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
  fontStyle: 'italic',
};
const clientLabelWrapperStyle = {
  padding: '10px',
  marginRight: '10px',
};
const messageTextStyle = {
  marginTop: '20px',
};
const rightGroupStyle = {
  display: 'flex',
};
const disableButtonStyle = {
  marginTop: '20px',
};

const soundIconStyle = {
  width: '14px',
  height: '14px',
};

export class IntroMessages extends PureComponent {
  static propTypes = {
    getMessages: PropTypes.func,
    disableIntroMessage: PropTypes.func,
    introMessagesList: PropTypes.array,
  };

  componentWillMount() {
    this.props.getMessages({ include: 'organization' });
  }

  disableMessage = (id) => () => {
    this.props.disableIntroMessage(id);
  };

  renderIntroMessageTitle = (text, originalFileName) => (
    <div style={messageTextStyle}>
      {originalFileName && <Icon name="sound" style={soundIconStyle} />}
      {` ${text || originalFileName}`}
    </div>
  );

  renderIntroMessages() {
    const { introMessagesList } = this.props;
    return introMessagesList.map(({ id, text, organization, originalFileName = '' }) => (
      <li key={id}>
        {this.renderIntroMessageTitle(text, originalFileName)}
        <div style={rightGroupStyle}>
          <div style={clientLabelWrapperStyle}>
            {organization && <div style={clientLabelStyle}>{organization.name}</div>}
          </div>
          <div>
            <InvisibleButton
              onClick={this.disableMessage({ id })}
              title="Disable message"
              style={disableButtonStyle}
            >
              <Icon name="crossGrey" />
            </InvisibleButton>
          </div>
        </div>
      </li>
    ));
  }

  render() {
    return (
      <Panel>
        <IntroMessageCreateForm {...this.props} />
        <MessagesList> {this.renderIntroMessages()}</MessagesList>
      </Panel>
    );
  }
}



// WEBPACK FOOTER //
// ./components/pages/AdminPage/IntroMessages.component.js